import React from "react";
import { Text, Linking, StyleSheet } from "react-native";
import colors from "../constants/colors";

export const renderLinks = (text: string | undefined) => {
  if (!text) {
    return null;
  }

  const regex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(regex);

  return parts?.map((part, index) => {
    if (regex.test(part)) {
      return (
        <Text
          key={index}
          style={styles.link}
          onPress={() => Linking.openURL(part)}
        >
          {part}
        </Text>
      );
    }
    return <Text key={index}>{part}</Text>;
  });
};

export const getCardStyle = (isMaleTurn: boolean) => {
  return {
    backgroundColor: isMaleTurn
      ? colors.maleBackground
      : colors.femaleBackground,
    borderRadius: 10,
    padding: 15,
    margin: 10,
  };
};

const styles = StyleSheet.create({
  link: {
    color: colors.linkColor,
    textDecorationLine: "underline",
  },
});
